/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFilterViewRequest
 */
export interface UpdateFilterViewRequest {
    /**
     * 
     */
    view_key?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    filters?: { [key: string]: any; };
    /**
     * 
     */
    is_default?: boolean;
}

/**
 * Check if a given object implements the UpdateFilterViewRequest interface.
 */
export function instanceOfUpdateFilterViewRequest(value: object): value is UpdateFilterViewRequest {
    return true;
}

export function UpdateFilterViewRequestFromJSON(json: any): UpdateFilterViewRequest {
    return UpdateFilterViewRequestFromJSONTyped(json, false);
}

export function UpdateFilterViewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFilterViewRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'view_key': json['view_key'] == null ? undefined : json['view_key'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'filters': json['filters'] == null ? undefined : json['filters'],
        'is_default': json['is_default'] == null ? undefined : json['is_default'],
    };
}

export function UpdateFilterViewRequestToJSON(json: any): UpdateFilterViewRequest {
    return UpdateFilterViewRequestToJSONTyped(json, false);
}

export function UpdateFilterViewRequestToJSONTyped(value?: UpdateFilterViewRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'view_key': value['view_key'],
        'name': value['name'],
        'description': value['description'],
        'filters': value['filters'],
        'is_default': value['is_default'],
    };
}

